import { getCookie } from './Auth/getCookie';

export const ANON_ID_COOKIE = 'tt_anon_id';

// Marketing packs click ids into Stripe client_reference_id values with this prefix.
const VERSIONED_CLIENT_REFERENCE_PREFIX = 'tt1';

export function isBareMarketingAnonId(value: string) {
  return !value.startsWith(VERSIONED_CLIENT_REFERENCE_PREFIX);
}

export function readMarketingAnonIdCookie(): string | null {
  const cookieValue = getCookie(ANON_ID_COOKIE);
  if (!cookieValue) return null;
  try {
    const decoded = decodeURIComponent(cookieValue);
    return isBareMarketingAnonId(decoded) ? decoded : null;
  } catch {
    // captureUtmParams runs before the app renders, so a malformed cookie must read as missing, not throw.
    return null;
  }
}

/**
 * RudderStack anonymous id from the marketing site. A `tt1…` Stripe
 * client_reference_id is not an anonymous id; click ids stay on the attribution cookie and URL.
 * The stored cookie wins over the URL, because captureUtmParams keeps the cookie.
 */
export function getMarketingAnonId(): string | null {
  const cookieValue = readMarketingAnonIdCookie();
  if (cookieValue) return cookieValue;

  const queryValue = new URLSearchParams(window.location.search).get(ANON_ID_COOKIE);
  return queryValue && isBareMarketingAnonId(queryValue) ? queryValue : null;
}
